module.exports = __webpack_public_path__ + "static/media/create_sections_add_main_section.67e2e2c2.mov";